import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Layout, Hero, Services, Projects, Contact } from '../components'; // Adjust the path if necessary

const StyledMainContainer = styled.main`
  counter-reset: section;
`;

const IndexPage = ({ location }) => (
  <Layout location={location}>
    <StyledMainContainer className="fillHeight">
      <Hero />
      {/* Personal sections - commented out for business page redesign */}
      {/* <About /> */}
      <Services />
      <Projects />
      {/* <Jobs /> */}
      {/* <Education /> */}
      {/* <Certification /> */}
      {/* <Publications /> */}
      <Contact />
    </StyledMainContainer>
  </Layout>
);

IndexPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default IndexPage;
